import {createTooltipTranslationProviderFromNamespace} from 'features/localizedTooltips/';
import {REGULATIONS_TRANSLATION_NAMESPACE} from '../regulationsConstants';

export const RegulationsTooltipTranslationProvider =
	createTooltipTranslationProviderFromNamespace(
		REGULATIONS_TRANSLATION_NAMESPACE,
	);
